import { render, staticRenderFns } from "./SignUserPicker.vue?vue&type=template&id=0d54faa4&scoped=true"
import script from "./SignUserPicker.vue?vue&type=script&lang=js"
export * from "./SignUserPicker.vue?vue&type=script&lang=js"
import style0 from "./SignUserPicker.vue?vue&type=style&index=0&id=0d54faa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d54faa4",
  null
  
)

export default component.exports